// Core client
export { AnalyticsClient } from './core/client';

// Types - Export everything for proper IntelliSense
export type {
  AnalyticsConfig,
  Fingerprint,
  Device,
  Screen,
  UTMParams,
  SessionInitResponse,
  PageviewEvent,
  CustomEvent,
  AnalyticsEvent,
  APIResponse,
  EventTrackResponse,
  HeartbeatResponse,
  SessionMetadata,
  RateLimitInfo,
} from './types';

// Utilities - Export for advanced users
export {
  collectFingerprint,
  detectDevice,
  getScreenInfo,
  parseUtmParams,
  classifyReferrer,
  getPageLoadTime,
  shouldRespectDoNotTrack,
} from './utils/device';

// Re-export types from index for convenience
export type { AnalyticsClient as AlginoClient } from './core/client';
